import Box from '@mui/material/Box';
import { useState } from 'react';

import type { DcrAttachment } from '../../_types/attachment';
import { AttachmentThumbnail } from '../AttachmentThumbnail/AttachmentThumbnail';
import { AttachmentViewer } from '../AttachmentViewer/AttachmentViewer';

import { attachmentGridStyles as sx } from './AttachmentGrid.styles';

type Props = {
	attachments: DcrAttachment[];
	removeAttachment?: (id: string) => void;
	size?: 'compact' | 'large';
};

export const AttachmentGrid = ({
	attachments,
	removeAttachment,
	size = 'compact'
}: Props) => {
	const [viewerIndex, setViewerIndex] = useState<number | null>(null);

	if (attachments.length === 0) return null;

	const handleClick = (attachment: DcrAttachment) => {
		const idx = attachments.findIndex(a => a.id === attachment.id);
		if (idx >= 0) setViewerIndex(idx);
	};

	return (
		<>
			<Box sx={sx.root(size)}>
				{attachments.map(attachment => (
					<AttachmentThumbnail
						key={attachment.id}
						attachment={attachment}
						size={size}
						onRemove={removeAttachment}
						onClick={handleClick}
					/>
				))}
			</Box>

			{viewerIndex !== null && (
				<AttachmentViewer
					attachments={attachments}
					initialIndex={viewerIndex}
					onClose={() => setViewerIndex(null)}
				/>
			)}
		</>
	);
};
